"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var local_storage_service_1 = require('./local-storage.service');
var LocalStorageModule = (function () {
    function LocalStorageModule() {
    }
    LocalStorageModule.withConfig = function (userConfig) {
        if (userConfig === void 0) { userConfig = {}; }
        return {
            ngModule: LocalStorageModule,
            providers: [
                { provide: 'LOCAL_STORAGE_SERVICE_CONFIG', useValue: userConfig }
            ]
        };
    };
    LocalStorageModule = __decorate([
        core_1.NgModule({
            providers: [
                local_storage_service_1.LocalStorageService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], LocalStorageModule);
    return LocalStorageModule;
}());
exports.LocalStorageModule = LocalStorageModule;
//# sourceMappingURL=local-storage.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-2-local-storage/dist/local-storage.module.js
// module id = 1052
// module chunks = 0